import React, { useMemo } from 'react';
import { SelectMenu } from '@scale/scaleui';
import BuilderHint from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderHint';
import { InteractionStepParams } from '@scale/shared/types/chat';
import { InteractionStepType } from '@scale/shared/types/chat/params';
import { TextCollectionFieldType } from '@scale/shared/types/params/textcollection';

interface DefaultTextCollectionFieldIdsBuilderProps {
  name: string;
  existingValue?: string | string[];
  updateProperty: (arg: string | string[]) => void;
  required?: boolean;
  hint?: string;
  allowMultiple?: boolean;
  taskTemplateParams?: Record<string, any>;
}

const DefaultTextCollectionFieldIdsBuilder = ({
  name,
  existingValue = [],
  updateProperty,
  required,
  hint,
  allowMultiple = false,
  taskTemplateParams,
}: DefaultTextCollectionFieldIdsBuilderProps) => {
  const fieldIds = useMemo(() => {
    const results: string[] = [];
    const stepsParams: InteractionStepParams[] = [
      ...(taskTemplateParams?.before ?? []),
      ...(taskTemplateParams?.turn ?? []),
      ...(taskTemplateParams?.after ?? []),
    ];
    stepsParams.forEach(step => {
      if (
        step.type === InteractionStepType.TextCollection ||
        step.type === InteractionStepType.TextCollectionPerResponse
      ) {
        for (const field of step.params.fields) {
          if (
            field.type === TextCollectionFieldType.Text ||
            field.type === TextCollectionFieldType.Number ||
            field.type === TextCollectionFieldType.Category
          ) {
            results.push(field.field_id);
          }
        }
      }
    });
    const templateVariables = Object.keys(taskTemplateParams?.templateVariables ?? {});
    return results.concat(templateVariables);
  }, [taskTemplateParams]);

  return (
    <div className="scaleui scaleui-tailwind scale-them">
      <label className="block text-sm font-medium leading-6 text-neutral-700">
        {name}
        {required && <span className="text-danger-400">*</span>}
      </label>
      <div className="flex">
        {allowMultiple ? (
          <SelectMenu
            className="w-4/5 max-w-lg"
            options={fieldIds.map(s => ({ id: s, name: s }))}
            selectedOptionId={(existingValue ?? []) as string[]}
            setSelected={value => updateProperty(value as string[])}
            multiple
          />
        ) : (
          <SelectMenu
            className="w-4/5 max-w-lg"
            options={fieldIds.map(s => ({ id: s, name: s }))}
            selectedOptionId={(existingValue ?? '') as string}
            setSelected={value => updateProperty(value as string)}
          />
        )}
        {hint && <BuilderHint name={name} hint={hint} />}
      </div>
    </div>
  );
};

export default DefaultTextCollectionFieldIdsBuilder;
